import { render, staticRenderFns } from "./CardMovement.vue?vue&type=template&id=4e5b62cb&scoped=true"
import script from "./CardMovement.js?vue&type=script&lang=js&external"
export * from "./CardMovement.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b62cb",
  null
  
)

export default component.exports